// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DDnXr","col":"styles_col__1RLmN"};